import request from '@/utils/request.js';

// 呼叫模块 接口api
export function CallingPhone(data) {
    // 打电话调取接口
    return request({
        url: '/Call/CallingPhone',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function GetCallInfoPageList(data) {
    // 话单分页列表
    return request({
        url: '/Call/GetCallInfoPageList',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function GetCallExpensePageList(data) {
    // 话单消费详细统计
    return request({
        url: '/Call/GetCallExpensePageList',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function GetCallDaliyReportPageList(data) {
    // 日报表
    return request({
        url: '/Call/GetCallDaliyReportPageList',
        method: 'post',
        data,
        apiType: 'java'
    });
}


export function IsCanSipDayOne(data) {
    // 拨打频次限制
    return request({
        url: '/Call/IsCanSipDayOne',
        method: 'post',
        data,
        apiType: 'java'
    });
}